(() => {
  'use strict';

  if (customElements.get('cm-events-map')) return;

  class CMEventsMap extends HTMLElement {
    connectedCallback() {
      if (this.isInitialised) return;

      this.isInitialised = true;
      this.controller = new AbortController();
      this.pins = [...this.querySelectorAll('[data-cm-city-pin]')];
      this.panels = [...this.querySelectorAll('[data-cm-city-panel]')];
      this.section = this.closest('.cm-events');
      this.eventCards = [
        ...(this.section?.querySelectorAll('[data-cm-city-card]') || []),
      ];

      if (this.pins.length === 0) return;

      const initialPin =
        this.pins.find((pin) => pin.classList.contains('is-selected')) ||
        this.pins[0];

      this.addEventListener(
        'pointerover',
        (event) => this.handlePinEvent(event),
        { signal: this.controller.signal },
      );
      this.addEventListener(
        'focusin',
        (event) => this.handlePinEvent(event),
        { signal: this.controller.signal },
      );
      this.addEventListener(
        'click',
        (event) => this.handlePinEvent(event),
        { signal: this.controller.signal },
      );
      document.addEventListener(
        'shopify:block:select',
        (event) => this.handleBlockSelect(event),
        { signal: this.controller.signal },
      );

      this.activate(initialPin.dataset.cmCityPin);
      this.dataset.cmEventsReady = 'true';
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.isInitialised = false;
    }

    handlePinEvent(event) {
      const pin = event.target.closest('[data-cm-city-pin]');
      if (!pin || !this.contains(pin)) return;

      this.activate(pin.dataset.cmCityPin);
    }

    handleBlockSelect(event) {
      const blockId =
        event.detail?.blockId ||
        event.target?.closest?.('[data-block-id]')?.dataset.blockId;

      if (!blockId) return;

      const eventCard = this.eventCards.find(
        (card) => card.dataset.blockId === blockId,
      );
      const cityId = eventCard?.dataset.cmCityCard;

      if (cityId) this.activate(cityId);
    }

    activate(cityId) {
      if (!cityId || cityId === this.activeCityId) return;

      const selectedPin = this.pins.find(
        (pin) => pin.dataset.cmCityPin === cityId,
      );
      const selectedPanel = this.panels.find(
        (panel) => panel.dataset.cmCityPanel === cityId,
      );

      if (!selectedPin || !selectedPanel) return;

      this.activeCityId = cityId;

      this.pins.forEach((pin) => {
        const isSelected = pin.dataset.cmCityPin === cityId;

        pin.classList.toggle('is-selected', isSelected);
        pin.setAttribute('aria-expanded', String(isSelected));
      });

      this.panels.forEach((panel) => {
        const isSelected = panel.dataset.cmCityPanel === cityId;

        panel.classList.toggle('is-selected', isSelected);
        panel.hidden = !isSelected;
        panel.setAttribute('aria-hidden', String(!isSelected));
        panel.toggleAttribute('inert', !isSelected);
      });

      this.eventCards.forEach((card) => {
        card.classList.toggle(
          'is-map-selected',
          card.dataset.cmCityCard === cityId,
        );
      });
    }
  }

  customElements.define('cm-events-map', CMEventsMap);
})();

